import { useQuery } from 'react-query'
import { fetchSalaryCalculation, SalaryCalculationItem } from '../../api/salaryCalculation'

type SalaryCalculationQuery = {
  practitionerReferenceId: string
  periodStart: string
  periodEnd: string
}

const useGetSalaryCalculation = ({ practitionerReferenceId, periodStart, periodEnd }: SalaryCalculationQuery) => {
  const queryKey = [`salary-calculation-${practitionerReferenceId}-${periodStart}-${periodEnd}`]

  return useQuery<SalaryCalculationItem[]>(
    queryKey,
    () => fetchSalaryCalculation(practitionerReferenceId, periodStart, periodEnd),
    { enabled: !!practitionerReferenceId && !!periodStart && !!periodEnd }
  )
}

export default useGetSalaryCalculation
